import { makeStyles } from '@mui/styles';
const loginFormStyles = makeStyles(() => ({
    container: {
        width: '100%',
    },
    submitButton: {},
    forgotPasswordButton: {
        float: 'right',
        width: 'fit-content',
    },
    loginContainer: {},
    loginForm: {},
}), { name: 'Login_Form' });
export default loginFormStyles;
//# sourceMappingURL=loginForm.styles.js.map